module.exports = __webpack_public_path__ + "img/img12.5fb5073b.svg";